"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEntity = exports.relationshipFieldDerivers = exports.entityTaxonomyTreeFormFields = exports.entityTaxonomyFormFieldsWithDescription = exports.entityTaxonomyFormFields = exports.entityStandardFormFields = exports.entityCoreFormFields = exports.FORM_STATE_DEFAULT = exports.LIST_STATE_DEFAULT = exports.ITEMS_PER_PAGE = void 0;
var sprintf_js_1 = require("sprintf-js");
var lodash_1 = require("lodash");
var pluralize_1 = __importStar(require("pluralize"));
var immer_1 = __importDefault(require("immer"));
var entity_activity_subject_1 = require("../components/entities/entity-activity-subject");
var entity_activity_details_1 = require("../components/entities/entity-activity-details");
var title_case_1 = require("./title-case");
var entity_create_mutation_field_name_1 = require("./entity-create-mutation-field-name");
var entity_update_mutation_field_name_1 = require("./entity-update-mutation-field-name");
var route_1 = require("./route");
var app_section_navigation_item_1 = require("./app-section-navigation-item");
var entity_filter_1 = require("./entity-filter");
var entity_linked_select_filter_1 = require("./entity-linked-select-filter");
var entity_select_transform_1 = require("./entity-select-transform");
var entity_select_filter_1 = require("./entity-select-filter");
var entity_checkbox_field_1 = require("./entity-checkbox-field");
var entity_text_field_1 = require("./entity-text-field");
var entity_linked_select_field_1 = require("./entity-linked-select-field");
var entity_linked_table_field_1 = require("./entity-linked-table-field");
var entity_date_field_1 = require("./entity-date-field");
var entity_file_field_1 = require("./entity-file-field");
var entity_image_field_1 = require("./entity-image-field");
var entity_long_text_field_1 = require("./entity-long-text-field");
var entity_hidden_field_1 = require("./entity-hidden-field");
var entity_select_field_1 = require("./entity-select-field");
var entity_table_column_1 = require("./entity-table-column");
var entity_color_field_1 = require("./entity-color-field");
var entity_json_field_1 = require("./entity-json-field");
var entity_reference_field_1 = require("./entity-reference-field");
var current_user_can_1 = require("./current-user-can");
exports.ITEMS_PER_PAGE = 9;
exports.LIST_STATE_DEFAULT = {
  filter: {
    isPublished: {
      is: true
    }
  },
  orderBy: {
    fieldName: "name",
    desc: false
  },
  limit: exports.ITEMS_PER_PAGE,
  skip: 0
};
exports.FORM_STATE_DEFAULT = {
  error: '',
  page: 0
};
// perhaps make this configurable?
var MANAGE_ROUTES = ['create', 'update'];
var ROUTE_MAP = {
  create: 'create/*',
  details: ':slug/*',
  list: 'list/',
  listRedirect: '',
  update: 'update/:id/*'
};
var onNameBlur = function (context) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      if (context.onNameBlur) {
        context.onNameBlur(context.value);
      }
      return [2 /*return*/];
    });
  });
};
var ENTITY_FILTER_CREATORS = {
  linked: entity_linked_select_filter_1.entityLinkedSelectFilter,
  select: entity_select_filter_1.entitySelectFilter
};
var ENTITY_FIELD_CREATORS = {
  id: entity_hidden_field_1.entityIdField,
  name: entity_text_field_1.entityNameField,
  entityReference: entity_reference_field_1.entityReferenceField,
  entityReferenceMultiple: entity_reference_field_1.entityReferenceFieldMultiple,
  description: entity_long_text_field_1.entityDescriptionField,
  summary: entity_long_text_field_1.entitySummaryField,
  content: entity_long_text_field_1.entityContentField,
  hidden: entity_hidden_field_1.entityHiddenField,
  nameHidden: entity_hidden_field_1.entityHiddenNameField,
  boolean: entity_checkbox_field_1.entityCheckboxField,
  banner: entity_linked_table_field_1.entityBannerField,
  text: entity_text_field_1.entityTextField,
  textArea: entity_text_field_1.entityTextAreaField,
  linked: entity_linked_select_field_1.entityLinkedSelectField,
  linkedMultiple: entity_linked_select_field_1.entityLinkedSelectField,
  linkedTable: entity_linked_table_field_1.entityLinkedTableField,
  select: entity_select_field_1.entitySelectField,
  date: entity_date_field_1.entityDateField,
  dateRange: entity_date_field_1.entityDateRangeField,
  datetime: entity_date_field_1.entityDateTimeField,
  datetimeRange: entity_date_field_1.entityDateTimeRangeField,
  file: entity_file_field_1.entityFileField,
  url: entity_text_field_1.entityUrlField,
  color: entity_color_field_1.entityColorField,
  json: entity_json_field_1.entityJsonField,
  email: entity_text_field_1.entityEmailField,
  float: entity_text_field_1.entityFloatNumberField,
  int: entity_text_field_1.entityNumberField,
  image: entity_image_field_1.entityImageField,
  longText: entity_long_text_field_1.entityLongTextField,
  parent: entity_linked_select_field_1.entityLinkedSelectParentField,
  permissions: entity_linked_table_field_1.entityPermissionsField,
  visibility: entity_linked_select_field_1.entityVisibilitySelectField,
  grantedPerson: entity_linked_select_field_1.entityGrantedPersonField
};
exports.entityCoreFormFields = {
  id: {
    type: 'id'
  },
  name: {
    type: 'nameHidden'
  }
};
exports.entityStandardFormFields = {
  id: {
    type: 'id'
  },
  name: {
    type: 'name',
    required: true,
    onBlur: onNameBlur
  }
};
exports.entityTaxonomyFormFields = __assign({}, exports.entityStandardFormFields);
exports.entityTaxonomyFormFieldsWithDescription = __assign(__assign({}, exports.entityStandardFormFields), {
  description: {
    type: 'description'
  }
});
exports.entityTaxonomyTreeFormFields = __assign(__assign({}, exports.entityTaxonomyFormFields), {
  parent: {
    type: 'parent'
  }
});
exports.relationshipFieldDerivers = {};
var entityPluralLabel = function (config, template) {
  if (template === void 0) {
    template = '%s';
  }
  return (0, sprintf_js_1.sprintf)(template, config.pluralLabel || (0, lodash_1.startCase)(config.name));
};
var entityLabel = function (config, template) {
  if (template === void 0) {
    template = '%s';
  }
  return (0, sprintf_js_1.sprintf)(template, config.label || (0, lodash_1.startCase)(config.name));
};
// export const createEntitySlugDependencies: 
/** Safely create an entity config ensuring objects are correctly provided as empty */
var createEntity = function (config, context) {
  var _a, _b, _c, _d, _e, _f, _g;
  if (!config.name) {
    return null;
  }
  ;
  var useEntityBySlugQueries = process.env.USE_ENTITY_BY_SLUG_QUERIES === 'true';
  var entityTypeName = config.name;
  var appSections = context.appSections;
  var name = entityTypeName;
  var pluralName = config.pluralName || (0, pluralize_1.default)(config.name);
  var allName = config.allName || "all".concat(pluralName);
  var extraFields = config.extraFields || {};
  var extraFieldSets = config.extraFieldSets || [];
  var valueImageStyle = config.valueImageStyle || 'bubble';
  var aliasOf = config.aliasOf || config.name;
  var typeName = config.typeName || config.aliasOf || config.name || (0, title_case_1.titleCase)(aliasOf);
  var pluralTypeName = config.pluralTypeName || (0, pluralize_1.default)(typeName);
  var leadingPluralTypeName = config.leadingPluralTypeName || (0, lodash_1.camelCase)(pluralTypeName);
  var pluralFieldName = config.pluralFieldName || (0, lodash_1.camelCase)(pluralTypeName);
  var fieldName = config.fieldName || (0, lodash_1.camelCase)(typeName);
  var slug = config.slug || (0, lodash_1.kebabCase)(config.name);
  var label = config.label || (0, lodash_1.startCase)(config.name);
  var pluralLabel = config.pluralLabel || (0, pluralize_1.default)(label);
  var shouldConfirmDuplicates = config.shouldConfirmDuplicates || function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/, true];
      });
    });
  };
  var imageStyle = config.imageStyle || 'default';
  var imageInset = config.imageInset || 0;
  var conversationModeratorField = config.conversationModeratorField || '';
  var defaultSortField = config.defaultSortField || 'name';
  var useSites = !!config.useSites;
  var useSiteSlug = config.useSiteSlug === undefined ? useSites : !!config.useSiteSlug;
  var includeInSearch = !!config.includeInSearch;
  var aLabel = config.aLabel || ((0, lodash_1.includes)(['a', 'e', 'i', 'o', 'u'], label.toLowerCase().charAt(0)) ? "an ".concat(label) : "a ".concat(label));
  var templatePlaceholder = config.templatePlaceholder || (0, lodash_1.snakeCase)(typeName).toUpperCase();
  var templatePlaceholderPlural = config.templatePlaceholderPlural || (0, lodash_1.snakeCase)(pluralTypeName).toUpperCase();
  var templatePlaceholderA = config.templatePlaceholderA || "A_".concat((0, lodash_1.snakeCase)(typeName).toUpperCase());
  var oneLabel = config.oneLabel || "1 ".concat(label);
  var nLabel = config.nLabel || "%d ".concat(pluralLabel);
  var zeroLabel = config.zeroLabel || "No ".concat(pluralLabel);
  var countLabel = function (_a) {
    var t = _a.t,
      count = _a.count;
    var template = count === 0 ? zeroLabel : count === 1 ? oneLabel : nLabel;
    return (0, sprintf_js_1.sprintf)(template, count);
  };
  var options = config.options || {};
  var singleIdFieldName = useEntityBySlugQueries ? 'slug' : 'id';
  var singleTypeName = config.singleTypeName || (0, lodash_1.camelCase)(typeName);
  var singleBySlugName = "".concat((singleTypeName || (0, lodash_1.camelCase)(typeName)).replace('BySlug', '')).concat(useEntityBySlugQueries ? 'BySlug' : '');
  var updateTypeName = config.updateTypeName || (0, lodash_1.camelCase)(typeName);
  var scopeSlug = config.scopeSlug || (0, lodash_1.kebabCase)((0, pluralize_1.default)(config.name)); // this is the unmodified plural slug name, for comparing auth scopes. This must match the server's scope value 
  var scopes = config.createScopes ? {
    read: "read:".concat(scopeSlug),
    create: "create:".concat(scopeSlug),
    update: "update:".concat(scopeSlug),
    delete: "delete:".concat(scopeSlug),
    write: "write:".concat(scopeSlug),
    list: "list:".concat(scopeSlug)
  } : {};
  var pluralSlug = config.pluralSlug || (0, pluralize_1.default)(slug);
  var icon = config.icon || function (_a) {
    var icons = _a.icons;
    var specificIcon = icons.Entities[name];
    if (!specificIcon) {
      if (name.match(/type/i)) {
        return icons.Entities.ImpactResultType;
      }
    }
    return specificIcon;
  };
  var taxonomy = config.taxonomy || {};
  var type = config.type || 'standard';
  var removeMessage = "Are you sure you wish to remove this <b>%s</b> from the platform</b>? <br /><br />This is <b>not reversible</b>.";
  var usePublishStatus = !!config.usePublishStatus;
  var useDuplicateCheck = config.useDuplicateCheck === undefined ? type === 'taxonomy' : config.useDuplicateCheck;
  var useRoundedImage = config.useRoundedImage;
  var useNetwork = !!config.useNetwork;
  var valueNamePath = config.valueNamePath || 'name';
  var useActive = !!config.useActive;
  var useMembership = !!config.useMembership;
  var useCreator = config.useCreator === undefined ? true : config.useCreator;
  var useCreated = config.useCreated === undefined ? true : config.useCreated;
  var useConversation = !!config.useConversation;
  var useFollowers = !!config.useConversation;
  var useModerators = !!config.useModerators;
  var useOpenGraph = config.useOpenGraph === undefined ? true : config.useOpenGraph;
  var useConnections = !!config.useConnections;
  var usePreview = !!config.usePreview;
  var useSlices = !!config.useSlices;
  var useViews = !!config.useViews || !!config.useSlices;
  var useSpaces = !!config.useSpaces;
  var sectionName = config.sectionName || config.groupName || 'Taxonomies';
  var groupName = config.groupName || 'Other';
  var includeInMetrics = config.includeInMetrics === undefined ? includeInSearch : !!config.includeInMetrics;
  var usePermissions = !!config.usePermissions;
  var useVisibility = !!config.useVisibility;
  var canEmbed = !!config.canEmbed;
  var canCreateInConversation = !!config.canCreateInConversation;
  var followingFieldName = config.followingFieldName || "following".concat(pluralTypeName);
  var appSectionName = config.appSectionName;
  var appSection =
  // first, try to return the named appSection from the configuration
  // this may not always yield a result, as the instance configuration may delete certain sections
  // @ts-ignore
  appSections[appSectionName] ||
  // otherwise, try to find an appSection with a child listing the entity
  (0, lodash_1.find)(appSections, function (section) {
    return !!section.children.find(function (child) {
      return (0, lodash_1.includes)(['list', 'list-expandable'], child.type) && child.entityTypeName === name;
    });
  }) || appSections.platform;
  var breadcrumbs = config.breadcrumbs || (type === 'taxonomy' ? function (_a) {
    var items = _a.items,
      depth = _a.depth,
      appSections = _a.appSections,
      entities = _a.entities,
      icons = _a.icons,
      t = _a.t;
    // make taxonomies appear to be grouped under the platform / taxonomies appSection 
    var platformSection = (0, lodash_1.find)(appSections, function (appSection) {
      return appSection.id === 'platform';
    });
    var platformChild = platformSection && platformSection.children.find(function (child) {
      return child.id === 'platform/taxonomies';
    });
    // create an AppSectionChild definition to feed in 
    var entityAppSectionChild = {
      id: pluralSlug,
      path: "/".concat(platformSection.path, "/").concat(platformChild.path, "/").concat(pluralSlug),
      type: 'list',
      entityTypeName: name
    };
    var entityChildItem = (0, app_section_navigation_item_1.appSectionNavigationItem)({
      appSection: platformSection,
      appSectionChild: entityAppSectionChild,
      entities: entities,
      icons: icons,
      t: t
    });
    entityChildItem.isCurrent = false;
    entityChildItem.isActive = true;
    return [entityChildItem, items[0]];
  } : function (_a) {
    var items = _a.items;
    return items;
  });
  var duplicateDialogConfigInput = config.duplicateDialogConfig || {
    templates: {
      default: {},
      linked: {}
    }
  };
  var duplicateDialogConfigTemplates = duplicateDialogConfigInput.templates || {
    default: {},
    linked: {}
  };
  // TODO - sprintf needs to be replaced with handlebars, so we can symbolically include PARTICULAR strings
  var duplicateDialogConfig = __assign(__assign({
    title: 'Similar %s Detected',
    cancelLabel: 'Cancel Creation',
    continueLabel: 'Continue Creating',
    linkLabel: 'Link Existing %s'
  }, duplicateDialogConfigInput), {
    templates: {
      default: __assign(__assign({}, duplicateDialogConfigTemplates.default || {}), {
        info: 'You are trying to create <b>%s</b> named <b>%s</b> but we have found something similar already in the platform</b>.',
        question: 'Do you wish to <b>Continue creating this %s with the same name</b>, or would you like to <b>Cancel</b>?'
      }),
      linked: __assign(__assign({}, duplicateDialogConfigTemplates.linked || {}), {
        info: 'You are trying to create <b>%s</b> named <b>%s</b> but we have found a something similar already in the platform</b>.',
        question: 'Do you wish to <b>Continue creating this %s with the same name</b>, or would you like to <b>Link to the Existing Record</b> instead?'
      })
    }
  });
  var orderByFields = config.orderByFields || ['name', 'created'];
  var orderBySchemaFields = orderByFields.map(function (field) {
    return field.split('=')[0];
  });
  var orderBySchemaFieldsByColumnName = (0, lodash_1.mapValues)((0, lodash_1.keyBy)(orderByFields.map(function (tuple) {
    var parts = tuple.split('=');
    var _a = __read(parts, 2),
      columnName = _a[0],
      fieldName = _a[1];
    return {
      columnName: columnName,
      fieldName: fieldName || columnName
    };
  }), 'columnName'), function (tuple) {
    return tuple.fieldName;
  });
  var orderByColumnNamesBySchemaField = (0, lodash_1.invert)(orderBySchemaFieldsByColumnName);
  orderByFields.map(function (field) {
    return field.split('=')[0];
  });
  var ret = {
    name: name,
    singleIdFieldName: singleIdFieldName,
    valueImageStyle: valueImageStyle,
    valueNamePath: valueNamePath,
    imageStyle: imageStyle,
    imageInset: imageInset,
    aliasOf: aliasOf,
    conversationModeratorField: conversationModeratorField,
    scopes: scopes,
    canEmbed: canEmbed,
    useSites: useSites,
    useSiteSlug: useSiteSlug,
    extraFields: extraFields,
    extraFieldSets: extraFieldSets,
    canCreateInConversation: canCreateInConversation,
    includeInSearch: includeInSearch,
    includeInMetrics: includeInMetrics,
    useCreator: useCreator,
    useCreated: useCreated,
    shouldConfirmDuplicates: shouldConfirmDuplicates,
    usePublishStatus: usePublishStatus,
    useDuplicateCheck: useDuplicateCheck,
    useOpenGraph: useOpenGraph,
    useMembership: useMembership,
    useActive: useActive,
    useNetwork: useNetwork,
    usePreview: usePreview,
    useConnections: useConnections,
    useConversation: useConversation,
    useSlices: useSlices,
    useViews: useViews,
    useSpaces: useSpaces,
    useFollowers: useFollowers,
    useModerators: useModerators,
    usePermissions: usePermissions,
    groupName: groupName,
    sectionName: sectionName,
    useVisibility: useVisibility,
    pluralName: pluralName,
    allName: allName,
    templatePlaceholder: templatePlaceholder,
    templatePlaceholderA: templatePlaceholderA,
    templatePlaceholderPlural: templatePlaceholderPlural,
    scopeSlug: scopeSlug,
    type: type,
    orderByFields: orderByFields,
    orderBySchemaFields: orderBySchemaFields,
    orderBySchemaFieldsByColumnName: orderBySchemaFieldsByColumnName,
    orderByColumnNamesBySchemaField: orderByColumnNamesBySchemaField,
    relatedEntities: config.relatedEntities || [],
    typeName: typeName,
    singleTypeName: singleTypeName,
    singleBySlugName: singleBySlugName,
    updateTypeName: updateTypeName,
    pluralTypeName: pluralTypeName,
    pluralFieldName: pluralFieldName,
    fieldName: fieldName,
    leadingPluralTypeName: leadingPluralTypeName,
    followingFieldName: followingFieldName,
    slug: slug,
    duplicateDialogConfig: duplicateDialogConfig,
    pluralSlug: pluralSlug,
    label: label,
    pluralLabel: pluralLabel,
    aLabel: aLabel,
    oneLabel: oneLabel,
    nLabel: nLabel,
    taxonomy: taxonomy,
    countLabel: countLabel,
    defaultSortField: defaultSortField,
    zeroLabel: zeroLabel,
    appSectionName: appSectionName,
    appSection: appSection,
    removeMessage: removeMessage,
    breadcrumbs: breadcrumbs,
    options: options
  };
  var filterInputTypeName = config.filterInputTypeName || config.aliasOf || typeName;
  var routeSection = config.routeSection || (ret.type === 'taxonomy' ? 'taxonomies' : '');
  var autoRoutes = config.autoRoutes;
  if ((0, lodash_1.includes)(autoRoutes, 'list')) {
    autoRoutes.push('listRedirect');
  }
  // create any auto-routes - auto routes are simply route paths which are auto-generated based on the pluralized version of the entity slug
  var routes = (0, immer_1.default)(config.routes || {}, function (draft) {
    (config.autoRoutes || []).map(function (route) {
      var isManageRoute = MANAGE_ROUTES.indexOf(route) !== -1;
      var prefix = isManageRoute ? 'manage' : '';
      draft[route] = "".concat((0, lodash_1.filter)([prefix, isManageRoute ? routeSection : '', pluralSlug, ROUTE_MAP[route] === undefined ? route : ROUTE_MAP[route]]).join('/'));
    });
  });
  var paths = (0, immer_1.default)(config.routes || {}, function (draft) {
    (config.autoRoutes || []).map(function (route) {
      var isManageRoute = MANAGE_ROUTES.indexOf(route) !== -1;
      var prefix = isManageRoute ? 'manage' : '';
      draft[route] = "/".concat((0, lodash_1.filter)([prefix, isManageRoute ? routeSection : '', pluralSlug, ROUTE_MAP[route] === undefined ? route : ROUTE_MAP[route]]).join('/'));
    });
  });
  var formConfig = config.form || {};
  var impliedTypeName = function (type) {
    if (type === 'banner') {
      return 'Banner';
    }
    if (type === 'parent') {
      // THIS definition name
      return name;
    }
  };
  // console.log(ret.name, "FIELDS?", formConfig.fields);
  var baseFields = ret.type === 'taxonomy' ? exports.entityTaxonomyFormFields : exports.entityStandardFormFields;
  if (useSiteSlug) {
    baseFields = (0, lodash_1.pickBy)(__assign({
      name: baseFields.name,
      siteSlug: useSiteSlug && {
        type: 'text',
        isVisible: function () {
          return (0, current_user_can_1.currentUserCanAdmin)();
        },
        label: 'Website Slug',
        recommended: false,
        description: "This is the part of the URL which uniquely identifies this ".concat(label, " in a website, and should be a lower-case version of the name field with words separated by dashes.<br><br><b>NB: Changing this slug after this ").concat(label, " has a page on a published website will change that page's URL.</b> Take care, as this could mean that any distributed links to this item (for example on social media) may result in a Page Not Found (404) error.")
      },
      sites: useSites && {
        type: 'linkedMultiple',
        isVisible: function () {
          return (0, current_user_can_1.currentUserCanAdmin)();
        },
        entityTypeName: 'Site',
        description: "Which {{SITES}} can this ".concat(label, " appear in? Note: this does not automatically setup a {{SITE}}, it's used is to identify which {{SITES}} may include this ").concat(label, ".")
      }
    }, (0, lodash_1.omit)(baseFields, 'name')));
  }
  var formFields = (0, lodash_1.pickBy)(__assign(__assign(__assign(__assign(__assign(__assign({}, baseFields || {}), formConfig.fields), useSlices ? {
    slices: {
      type: 'linkedTable',
      fieldSet: 'slices',
      entityTypeName: 'Slice',
      description: 'As an alternative to regular content fields, you can edit the content for this item by specifying a series of {{SLICES}}, each with their own layout. '
    }
  } : {}), useViews ? {
    views: {
      type: 'linkedTable',
      fieldSet: 'views',
      entityTypeName: 'View',
      description: 'As an alternative to regular content fields, or slices, you can edit the content for this item by specifying a series of {{VIEWS}}, each of which can contain their own slices. This is useful for setting up content structures for pages which display tabbed content, where each view represents a tab'
    }
  } : {}), useSpaces ? {
    spaces: {
      type: 'linkedMultiple',
      fieldSet: 'spaces',
      entityTypeName: 'Space',
      description: 'Which {{SPACES}} are associated with this {{ENTITY}}?'
    }
  } : {}), extraFields || {}));
  var form = __assign(__assign({
    paginate: true,
    initialState: exports.FORM_STATE_DEFAULT,
    transformInput: function (_a) {
      return __awaiter(void 0, [_a], void 0, function (_b) {
        var input = _b.input;
        return __generator(this, function (_c) {
          return [2 /*return*/, input];
        });
      });
    }
  }, formConfig), {
    // augment preset 'linked' fields with implied EntityTypeName (needed for auto-infer of queries)
    fields: (0, lodash_1.mapValues)(formFields, function (f) {
      return __assign(__assign({}, f), {
        entityTypeName: f.entityTypeName || impliedTypeName(f.type)
      });
    }),
    reverseFields: formConfig.reverseFields || {},
    modal: __assign({
      maxWidth: ret.type === 'taxonomy' ? "768px" : "92vw",
      fill: formConfig.fieldSets && formConfig.fieldSets.length > 1
    }, formConfig.modal || {}),
    createFields: function (context) {
      var fields = formFields || exports.entityStandardFormFields;
      if (useVisibility) {
        fields.visibility = {
          type: 'visibility'
        };
      }
      if (usePermissions) {
        fields.permissions = {
          type: 'permissions',
          fieldSet: 'permissions'
        };
      }
      if (useModerators) {
        fields.moderators = fields.moderators || {
          type: 'linkedMultiple',
          entityTypeName: 'Person',
          label: 'Conversation Moderators',
          fieldSet: 'admin',
          recommended: false,
          description: (0, sprintf_js_1.sprintf)("Who is responsible for moderating the Conversation about this %s?", context.definition.label)
        };
      }
      // console.log(`CREATING FIELDS FOR ${context.entityTypeName}`);
      return (0, lodash_1.filter)((0, lodash_1.map)(fields, function (spec, name) {
        var fieldType = spec.type || 'linked';
        var isInvisible = false;
        var isMulti = !!spec.isMulti || (0, lodash_1.includes)(["linkedMultiple", ""], fieldType) || (0, pluralize_1.isPlural)(name) && (0, lodash_1.includes)(["linkedTable", "linked"], fieldType);
        if (spec.isVisible && !spec.isVisible(context)) {
          isInvisible = true;
        }
        var creator = ENTITY_FIELD_CREATORS[fieldType] || ENTITY_FIELD_CREATORS['text'];
        // if the entity type doesn't exist, don't create the field
        if (spec.entityTypeName && !context.entities[spec.entityTypeName]) {
          return null;
        }
        if (spec.requiredEntityTypeName && !context.entities[spec.requiredEntityTypeName]) {
          return null;
        }
        // this field should not be made editable in the form
        if (spec.specOnly) {
          return null;
        }
        return creator(__assign(__assign({}, spec), {
          isInvisible: isInvisible,
          isMulti: isMulti,
          context: context,
          name: name
        }));
      }));
    }
  });
  // console.log(typeName, form);
  form.fieldsMemoize = form.fieldsMemoize === undefined ? true : form.fieldsMemoize;
  form.fieldSets = (0, lodash_1.uniqBy)(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(form.fieldSets || [{
    name: "overview"
  }]), false), __read(extraFieldSets || []), false), __read(useSlices ? [{
    name: "slices"
  }] : []), false), __read(useViews ? [{
    name: "views"
  }] : []), false), __read(useSpaces ? [{
    name: "spaces"
  }] : []), false), __read(usePermissions ? [{
    name: "permissions"
  }] : []), false), [{
    name: "admin"
  }], false), 'name');
  var linkedFields = (0, lodash_1.pickBy)(form.fields, function (field) {
    return (0, lodash_1.includes)(["linked", "linkedMultiple", "banner", "parent"], field.type);
  });
  var entityReferenceFields = (0, lodash_1.pickBy)(form.fields, function (field) {
    return (0, lodash_1.includes)(["entityReference", "entityReferenceMultiple"], field.type);
  });
  var linkedTableFields = (0, lodash_1.pickBy)(form.fields, function (field) {
    return (0, lodash_1.includes)(["linkedTable"], field.type);
  });
  var contentNodeFields = (0, lodash_1.pickBy)(form.fields, function (field) {
    return (0, lodash_1.includes)(["longText", "textArea", "json", "summary", "description", "content"], field.type);
  });
  var scalarFields = (0, lodash_1.pickBy)(form.fields, function (field) {
    return (0, lodash_1.includes)(["text", "boolean", "color", "int", "float", "date", "hidden", "datetimeRange", "dateRange", "datetime", "url", "email"], field.type);
  });
  var imageFields = (0, lodash_1.pickBy)(form.fields, function (field) {
    return (0, lodash_1.includes)(["image"], field.type);
  });
  var fileFields = (0, lodash_1.pickBy)(form.fields, function (field) {
    return (0, lodash_1.includes)(["file"], field.type);
  });
  /* Setup configuration for create forms */
  var create = __assign(__assign({
    label: entityLabel(ret, 'Add %s'),
    newLabel: entityLabel(ret, 'Add New %s')
  }, config.create || {}), {
    initialState: (0, lodash_1.get)(config, 'create.initialState', function () {
      return {};
    })
  });
  /* Setup configuration for update forms */
  var updateInputConfig = config.update || {};
  var deleteInputConfig = config.delete || {};
  var del = __assign({
    label: entityLabel(ret, 'Delete %s')
  }, deleteInputConfig);
  var update = __assign({
    label: entityLabel(ret, 'Edit %s'),
    valueKeys: function (fieldName) {
      return fieldName === 'links' || fieldName === 'link' ? ['id'] : ['url', 'id', 'text'];
    }
  }, updateInputConfig);
  var card = __assign({
    hasEditControls: ret.type === 'taxonomy'
  }, config.card || {});
  var grid = __assign({
    divider: "full",
    spacing: 0,
    columns: 0,
    autoLink: true
  }, config.grid || {});
  // provide default table column deriver and cell data 
  var inputTable = config.table || {};
  var inputTableFields = inputTable.fieldNames && inputTable.fieldNames.length && inputTable.fieldNames.reduce(function (acc, fieldName) {
    acc[fieldName] = __assign(__assign({}, (inputTable.options || {})[fieldName]), (inputTable.fields || {})[fieldName]);
    return acc;
  }, {}) || inputTable.fields || (0, lodash_1.pickBy)({
    info: {
      title: "Info",
      weight: ret.type === 'taxonomy' ? 3 : 4.5
    },
    linkCount: ret.type === 'taxonomy' && {
      weight: 1
    },
    createdBy: {
      weight: 3
    }
  });
  // fill in defaults
  // @ts-ignore
  var tableFields = (0, lodash_1.mapValues)(inputTableFields, function (field, fieldName) {
    var type = field.as || field.type || entity_table_column_1.ENTITY_COLUMN_NAME_TYPES[fieldName] || 'text';
    // look for a field in the entity set 
    var columnFormField = form.fields[fieldName];
    if (!field.as) {
      if (columnFormField && columnFormField.type) {
        type = columnFormField.type;
      }
    }
    var entityTypeName = columnFormField && columnFormField.entityTypeName;
    var weight = field.weight || entity_table_column_1.ENTITY_TABLE_COLUMN_WEIGHTS_BY_TYPE[type] || entity_table_column_1.ENTITY_TABLE_COLUMN_WEIGHTS_BY_NAME[fieldName] || 1;
    var isMulti = type === "linkedMultiple";
    return (0, lodash_1.pickBy)(__assign(__assign({}, field), {
      isMulti: isMulti,
      name: fieldName,
      type: type,
      entityTypeName: entityTypeName,
      weight: weight
    }));
  });
  var table = __assign(__assign({}, inputTable), {
    fields: tableFields,
    linkedFields: (0, lodash_1.pickBy)(tableFields, function (field) {
      return (0, lodash_1.includes)(["linked", "linkedMultiple", "linkedTable", "banner", "grantedPerson", "parent"], field.type);
    }),
    personFields: (0, lodash_1.pickBy)(tableFields, function (field) {
      return (0, lodash_1.includes)(["grantedPerson", "createdBy", "updatedBy"], field.type);
    }),
    contentNodeFields: (0, lodash_1.pickBy)(tableFields, function (field) {
      return (0, lodash_1.includes)(["longText", "textArea", "json", "summary", "description", "content"], field.type);
    }),
    scalarFields: (0, lodash_1.pickBy)(tableFields, function (field) {
      return (0, lodash_1.includes)(["text", "count", "name", "int", "color", "float", "boolean", "date", "datetime", "hidden", "dateRange", "datetimeRange", "relativeDate", "url", "email"], field.type);
    }),
    imageFields: (0, lodash_1.pickBy)(tableFields, function (field) {
      return (0, lodash_1.includes)(["image"], field.type);
    }),
    fileFields: (0, lodash_1.pickBy)(tableFields, function (field) {
      return (0, lodash_1.includes)(["file"], field.type);
    })
  });
  var hasFilters = (0, lodash_1.get)(config, 'filters.fields', null) !== null;
  var defaultListState = exports.LIST_STATE_DEFAULT;
  if (ret.type === 'taxonomy') {
    defaultListState.limit = 30;
  }
  var graphInput = config.graph && config.graph.input || {};
  var graph = {
    input: __assign({
      depth: 1,
      types: [],
      excludeTypes: []
    }, graphInput)
  };
  var connectionsConfig = config.connections || {};
  var connectionsInput = connectionsConfig.input || {};
  var connections = __assign(__assign({
    sections: [],
    useGroups: false
  }, connectionsConfig), {
    activeEntityTypes: connectionsConfig.activeEntityTypes || [],
    input: __assign({
      depth: 1,
      types: []
    }, connectionsInput)
  });
  var networkConfig = config.network || {};
  var networkInput = networkConfig.input || {};
  var network = __assign(__assign({
    velocityDecay: 0.3
  }, networkConfig), {
    //    activeEntityTypes: connectionsConfig.activeEntityTypes || [],
    input: __assign({
      depth: 1,
      types: []
    }, networkInput)
  });
  var mapConfigInput = config.map || {};
  var mapConfig = __assign({
    description: (0, sprintf_js_1.sprintf)("Explore %s globally on an interactive map.", pluralLabel)
  }, mapConfigInput);
  var platformActivityConfig = config.platformActivity || {};
  var platformActivity = __assign({
    subjectComponent: entity_activity_subject_1.EntityActivitySubject,
    detailsComponent: entity_activity_details_1.EntityActivityDetails,
    tab: 'overview'
  }, platformActivityConfig || {});
  var bannerInput = config.banner || {};
  var banner = __assign(__assign({
    queryFields: ''
  }, bannerInput), {
    showDescription: bannerInput.showDescription === undefined ? true : !!bannerInput.showDescription
  });
  ret.banner = banner;
  var sidebar = __assign({
    sort: lodash_1.identity,
    queryFields: '',
    label: function (entity) {
      return entity.name;
    }
  }, config.sidebar || {});
  var showConversationsTab = config.list && config.list.showConversationsTab;
  var dittoMark = ((_a = config.export) === null || _a === void 0 ? void 0 : _a.dittoMark) || '.';
  var dittoMarkRepeat = !!((_b = config.export) === null || _b === void 0 ? void 0 : _b.dittoMarkRepeat);
  var useFriendlyHeaders = ((_c = config.export) === null || _c === void 0 ? void 0 : _c.useFriendlyHeaders) === undefined ? true : (_d = config.export) === null || _d === void 0 ? void 0 : _d.useFriendlyHeaders;
  var friendlyHeaderGlue = ((_e = config.export) === null || _e === void 0 ? void 0 : _e.friendlyHeaderGlue) || ' - ';
  var exportConfig = __assign(__assign({}, config.export || {}), {
    dittoMark: dittoMark,
    dittoMarkRepeat: dittoMarkRepeat,
    useFriendlyHeaders: useFriendlyHeaders,
    friendlyHeaderGlue: friendlyHeaderGlue,
    fieldTypes: ((_f = config.export) === null || _f === void 0 ? void 0 : _f.fieldTypes) || {},
    worksheets: (((_g = config.export) === null || _g === void 0 ? void 0 : _g.worksheets) || []).map(function (worksheetDefn) {
      var fieldLabel = (worksheetDefn === null || worksheetDefn === void 0 ? void 0 : worksheetDefn.fieldLabel) || (0, lodash_1.startCase)(worksheetDefn === null || worksheetDefn === void 0 ? void 0 : worksheetDefn.field);
      var autoName = "".concat(ret.pluralLabel).concat(friendlyHeaderGlue).concat(fieldLabel);
      if (autoName.length > 31) {
        // sheet names can't exceed 31 characters
        autoName = fieldLabel;
      }
      var name = ((worksheetDefn === null || worksheetDefn === void 0 ? void 0 : worksheetDefn.name) || autoName).substring(0, 31);
      var reverseFields = (worksheetDefn === null || worksheetDefn === void 0 ? void 0 : worksheetDefn.reverseFields) || ['name', 'slug'];
      // dittoFields are fields we'd like to show as a single ditto mark when the value didn't change from the previous
      // row. This visually groups the rows together, and makes it easier to read (without all the repetition). 
      var dittoFields = (worksheetDefn === null || worksheetDefn === void 0 ? void 0 : worksheetDefn.dittoFields) === undefined ? reverseFields.map(function (fieldName) {
        return "".concat(ret.singleTypeName, ".").concat(fieldName);
      }) : worksheetDefn === null || worksheetDefn === void 0 ? void 0 : worksheetDefn.dittoFields;
      // groupByField indicates that a single empty row will be inserted between groups of rows with the same value
      // this also makes related worksheets much easier to read. 
      var groupByField = (worksheetDefn === null || worksheetDefn === void 0 ? void 0 : worksheetDefn.groupByField) || (dittoFields === null || dittoFields === void 0 ? void 0 : dittoFields[0]);
      var sortByField = (worksheetDefn === null || worksheetDefn === void 0 ? void 0 : worksheetDefn.sortByField) === undefined ? groupByField : worksheetDefn === null || worksheetDefn === void 0 ? void 0 : worksheetDefn.sortByField;
      return __assign(__assign({}, worksheetDefn), {
        name: name,
        dittoMark: (worksheetDefn === null || worksheetDefn === void 0 ? void 0 : worksheetDefn.dittoMark) || dittoMark,
        dittoMarkRepeat: (worksheetDefn === null || worksheetDefn === void 0 ? void 0 : worksheetDefn.dittoMarkRepeat) === undefined ? dittoMarkRepeat : worksheetDefn === null || worksheetDefn === void 0 ? void 0 : worksheetDefn.dittoMarkRepeat,
        sortByField: sortByField,
        groupByField: groupByField,
        dittoFields: dittoFields
      });
    }) || []
  });
  var list = __assign(__assign({
    pad: true,
    scrollCheckInterval: 350,
    scrollThreshold: 850,
    hasFilters: hasFilters,
    showConversationsTab: !!showConversationsTab,
    filterItems: function (items) {
      return items;
    },
    hasSearch: config.list && config.list.hasSearch || hasFilters || ret.type === 'taxonomy',
    loadingLabel: entityPluralLabel(ret, 'Loading %s. Please wait...')
  }, config.list || {}), {
    grid: __assign(__assign({}, grid), config.list && config.list.grid),
    banner: __assign({
      title: entityPluralLabel(ret),
      content: ''
    }, config.list && config.list.banner || {}),
    queryFields: config.list && config.list.queryFields || (ret.type === 'taxonomy' ? "_linkCount openGraph { id title description { id text plain plainTruncated: plain(truncate: { words: 25 }) } date url author image { id url thumbnails { medium { id url } } } } createdBy { id name slug position isMember hasAccount organisation { id name slug location { id name slug state { id name abbr } openGraph { id image { id url thumbnails { medium { id url } } } } country { id name slug shorthand } } } openGraph { id image { id url thumbnails { medium { id url } } } } photo { id url thumbnails { id full { id url width height } } } location { id name slug state { id name abbr } openGraph { id image { id url thumbnails { medium { id url } } } } country { id name slug shorthand } } }" : ''),
    baseState: __assign({}, (0, lodash_1.get)(config, 'list.baseState', defaultListState))
  });
  ret.filterInputTypeName = filterInputTypeName;
  ret.select = __assign({
    debounceInterval: 250,
    maxWidth: '700px',
    queryName: "list".concat(ret.pluralTypeName),
    defaultOptions: true,
    optionBadge: function (option) {
      return option.entity && option.entity.isDraft && 'Draft';
    },
    searchPlaceholder: "Search for a %s...",
    textColor: 'text-mid'
  }, config.select || {});
  var select = ret.select;
  select.canCreate = select.canCreate || function (_a) {
    var currentUserCan = _a.currentUserCan;
    var can = currentUserCan(['write:any', "create:".concat(scopeSlug), "write:".concat(scopeSlug)]);
    return can;
  };
  // provide a default transformer 
  select.transform = select.transform || entity_select_transform_1.entitySelectTransform;
  select.loadOptionsFilter = select.loadOptionsFilter || function (inputValue) {
    return {
      _optionLabel: {
        contains: inputValue
      }
    };
  };
  select.filterArgs = select.filterArgs || (useActive ? 'filter: { isActive: { is: true } }' : '');
  var filtersConfig = config.filters || {};
  if (useSites) {
    filtersConfig.fields = __assign({
      sites: {
        entityTypeName: 'Site'
      }
    }, filtersConfig.fields || {});
  }
  var filters = __assign(__assign({}, filtersConfig), {
    createFields: function (context) {
      var fields = filtersConfig.fields || {};
      return (0, lodash_1.filter)((0, lodash_1.map)(fields, function (spec, name) {
        // if the entity type doesn't exist, don't create the filter
        if (spec.entityTypeName && !context.entities[spec.entityTypeName]) {
          return null;
        }
        var filterType = spec.type || 'linked';
        var creator = ENTITY_FILTER_CREATORS[filterType];
        return creator(__assign(__assign({}, spec), {
          context: context,
          name: name
        }));
      }));
    },
    values: filtersConfig.values || entity_filter_1.entityFilterValues
  });
  var configDetails = config.details || {};
  var details = __assign({
    pad: false,
    loadingLabel: entityLabel(config, 'Loading %s. Please wait...'),
    sections: configDetails.sections || function () {
      return [];
    }
  }, configDetails || {});
  ret = __assign(__assign(__assign(__assign({}, ret), {
    icon: icon,
    purpose: 'data',
    autoRoutes: config.autoRoutes || []
  }), config), {
    routes: routes,
    paths: paths,
    graph: graph,
    table: table,
    isPublic: !!config.isPublic,
    connections: connections,
    network: network,
    form: form,
    map: mapConfig,
    sidebar: sidebar,
    platformActivity: platformActivity,
    grid: grid,
    select: select,
    card: card,
    details: details,
    filters: filters,
    list: list,
    export: exportConfig,
    update: update,
    create: create,
    components: config.components || {},
    delete: del,
    linkedFields: linkedFields,
    linkedTableFields: linkedTableFields,
    entityReferenceFields: entityReferenceFields,
    contentNodeFields: contentNodeFields,
    scalarFields: scalarFields,
    imageFields: imageFields,
    fileFields: fileFields
  });
  var toRoute = ret.routes['details'];
  var toListRoute = ret.routes['list'];
  var toUpdateRoute = ret.routes['update'];
  var to = toRoute ? function (slug, _trailing) {
    return (0, route_1.route)("/".concat(toRoute), {
      slug: slug,
      _trailing: _trailing
    });
  } : function (slug) {
    return '';
  };
  var toList = toListRoute ? function (_trailing) {
    return (0, route_1.route)("/".concat(toListRoute), {
      _trailing: _trailing
    });
  } : function () {
    return '';
  };
  var toUpdate = toUpdateRoute ? function (id, _trailing) {
    return (0, route_1.route)("/".concat(toUpdateRoute), {
      id: id,
      _trailing: _trailing
    });
  } : function (id) {
    return '';
  };
  return __assign(__assign({}, ret), {
    to: to,
    toList: toList,
    toUpdate: toUpdate,
    details: __assign({
      label: 'Overview',
      filterState: function (entity, fieldName) {
        if (fieldName === void 0) {
          fieldName = singleTypeName;
        }
        return function (state) {
          return (0, immer_1.default)(state, function (draft) {
            draft.filter = draft.filter || {};
            draft.filter[fieldName] = {
              in: entity.slug
            };
          });
        };
      }
    }, ret.details),
    createTable: function (context) {
      return (0, lodash_1.filter)((0, lodash_1.map)(tableFields, function (field, fieldName) {
        var creator = entity_table_column_1.ENTITY_TABLE_COLUMN_CREATORS[field.type];
        if (creator) {
          return creator(__assign({
            context: context
          }, field));
        }
      }));
    },
    update: __assign(__assign({}, ret.update), {
      mutationFieldName: ret.update.mutationFieldName || (0, entity_update_mutation_field_name_1.entityUpdateMutationFieldName)(ret)
    }),
    create: __assign(__assign({}, ret.create), {
      mutationFieldName: ret.create.mutationFieldName || (0, entity_create_mutation_field_name_1.entityCreateMutationFieldName)(ret)
    }),
    list: __assign(__assign({}, ret.list), {
      searchPlaceholderShort: ret.list.searchPlaceholderShort || "Find By Name",
      searchPlaceholder: ret.list.searchPlaceholder || "Find %s By Name",
      emptyMessage: ret.list.emptyMessage || "No %s Found",
      loadingMessage: ret.list.loadingMessage || "Loading %s. Please wait...",
      resultsVariant: ret.list.resultsVariant || (ret.type === 'taxonomy' ? 'list' : 'grid'),
      queryFieldName: ret.list.queryFieldName || "list".concat((0, title_case_1.titleCase)(pluralTypeName))
    }),
    filters: __assign(__assign({}, ret.filters), {
      values: ret.filters.values || function (_a) {
        var filter = _a.filter;
        return {};
      }
    })
  });
};
exports.createEntity = createEntity;